import Articals from './Articals';

export default Articals;
